import { useCallback } from 'react'

const SCRIPT_ID = 'intercomFinAIAgent'

// @note: Had to override intercomSettings for the experiment (only for FinAI POC Trial)
// @note: user acceptance check tbd

const useIntercomFinAIAgentWidget = () => {
  const initializeIntercom = useCallback(() => {
    const intercomFunction = function () {
      // eslint-disable-next-line prefer-rest-params
      intercomFunction.c(arguments)
    } as unknown as {
      (args: unknown): void
      q: unknown[]
      c: (args: unknown) => void
    }

    // eslint-disable-next-line id-length
    intercomFunction.q = []
    // eslint-disable-next-line id-length
    intercomFunction.c = function (args: unknown) {
      intercomFunction.q.push(args)
    }

    window.intercomSettings = window.intercomFinAISettings
    window.IntercomFinAIAgent = intercomFunction
    window.IntercomFinAIAgent('boot', window.intercomSettings)
  }, [])

  const loadScript = useCallback(() => {
    const appId = window?.intercomFinAISettings?.app_id
    if (!appId || document.getElementById(SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.id = SCRIPT_ID
    script.src = `https://widget.intercom.io/widget/${appId}`
    document.head.appendChild(script)

    script.onload = () => {
      initializeIntercom()
    }

    script.onerror = () => {
      console.error('Failed to load Intercom script')
    }
  }, [initializeIntercom])

  const updateIntercom = useCallback((intercomFinAIAgent: Window['IntercomFinAIAgent']) => {
    if (typeof intercomFinAIAgent !== 'function') {
      return false
    }

    window.intercomSettings = window.intercomFinAISettings
    intercomFinAIAgent('reattach_activator')
    intercomFinAIAgent('update', window.intercomSettings)

    return true
  }, [])

  const loadIntercomFinAIAgent = useCallback(() => {
    const intercomFinAIAgent = window.IntercomFinAIAgent

    if (updateIntercom(intercomFinAIAgent)) {
      return
    }

    if (document.readyState === 'complete') {
      loadScript()
      return
    }

    window.addEventListener('load', loadScript, { once: true })
  }, [loadScript, updateIntercom])

  return {
    loadIntercomFinAIAgent,
  }
}

export default useIntercomFinAIAgentWidget
